<!-- =========================================================================================
  File Name: adminLog.vue
  Description: Record Admin Log
========================================================================================== -->

<template>
  <div id="record-admin">

    <vx-card title="管理员日志">
      <div slot="actions">
        <vx-input-group>
          <template slot="prepend">
            <flat-pickr v-model="startTime" :config="flatPickrConfig" class="flatpickr-input w-32"></flat-pickr>
          </template>
          <template slot="prepend">
            <flat-pickr v-model="endTime" :config="flatPickrConfig" class="flatpickr-input w-32"></flat-pickr>
          </template>
          <vs-input class="w-48" v-model="uid" placeholder="管理员ID / 用户名" />
          <template slot="append">
            <vs-select class="w-48" v-model="typeVal">
              <vs-select-item :key="index" :value="index" :text="item" v-for="(item, index) in typeList" />
            </vs-select>
          </template>
          <template slot="append">
            <div class="append-text bg-warning cursor-pointer" @click="search">
              <feather-icon icon="SearchIcon"></feather-icon>
            </div>
          </template>
        </vx-input-group>
      </div>
      <vs-table stripe :data="list" noDataText="暂无日志记录">
        <template slot="thead">
          <vs-th width="80">UID</vs-th>
          <vs-th width="100">用户名</vs-th>
          <vs-th width="130">类型</vs-th>
          <vs-th width="160">时间</vs-th>
          <!-- <vs-th width="120">IP</vs-th> -->
          <vs-th>客户端</vs-th>
          <vs-th width="150">备注</vs-th>
          <vs-th width="100">操作</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="index" v-for="(item, index) in list">
            <vs-td :data="item.uid">{{item.uid}}</vs-td>
            <vs-td :data="item.username">{{item.username}}</vs-td>
            <vs-td :data="item.type">{{item.type}}</vs-td>
            <vs-td :data="item.actionDate">{{item.actionDate.substring(0, item.actionDate.length - 3)}}</vs-td>
            <!-- <vs-td :data="item.actionIP">{{item.actionIP}}</vs-td> -->
            <vs-td :data="item.agentArr">
              <span class="font-bold">{{item.agentArr[0]}}</span>
              ({{item.agentArr[1]}})
            </vs-td>
            <vs-td :data="item.remark">{{item.remark === '' ? '无' : item.remark}}</vs-td>
            <vs-td>
              <vs-button color="danger" type="filled" size="small" @click="del" :data-index="index">删除</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <vs-pagination class="mt-6" :total="totalPage" v-model="page" goto />
    </vx-card>

  </div>
</template>

<script>

import { Mandarin as flatPickrZh } from 'flatpickr/dist/l10n/zh.js'

export default {
  data() {
    return {
      page: 1,
      totalPage: 1,
      list: [],
      startTime: '',
      endTime: '',
      shortname: '',
      uid: '',
      typeList: ['类型'],
      typeVal: 0,
      flatPickrConfig: {
        enableTime: false,
        dateFormat: 'Y-m-d',
        locale: flatPickrZh
      }
    }
  },
  watch: {
    page(newValue) {
      this.page = newValue
      this.load()
    }
  },
  methods: {
    load () {
      const postdata = {}
      postdata.authKey = localStorage.getItem('authKey')
      postdata.page = this.page
      postdata.start = this.startTime
      postdata.end = this.endTime
      postdata.uid = this.uid
      postdata.parent = this.parent
      postdata.remark = this.remark
      postdata.type = this.typeVal > 0 ? this.typeList[this.typeVal] : ''
      this.$utils.post('record-adminLogList', postdata).then(res => {
        this.list = res.list
        this.totalPage = Math.ceil(res.count / res.pagesize)
      })
    },
    del(e) {
      const index = e.currentTarget.dataset.index
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '确认',
        text: '确认删除该条记录吗?',
        acceptText: '确认',
        cancelText: '取消',
        accept: () => {
          const postdata = {}
          postdata.authKey = localStorage.getItem('authKey')
          postdata.id = this.list[index].id
          this.$utils.post('record-adminLogDelete', postdata).then(res => {
            this.$vs.dialog({
              title: '提示',
              text: res,
              acceptText: '确认'
            })
            this.load()
          })
        }
      })
    },
    search() {
      this.page = 1
      this.load()
    }
  },
  mounted () {
    // 初始化时间
    const myDate = new Date()
    this.endTime = this.$utils.addZero(myDate.getFullYear(), 2) + '-' + this.$utils.addZero((parseInt(myDate.getMonth()) + 1), 2) + '-' + this.$utils.addZero(myDate.getDate(), 2)
    myDate.setTime(myDate.getTime() - 86400000 * 3)
    this.startTime = this.$utils.addZero(myDate.getFullYear(), 2) + '-' + this.$utils.addZero((parseInt(myDate.getMonth()) + 1), 2) + '-' + this.$utils.addZero(myDate.getDate(), 2)

    // 状态
    this.$utils.post('record-adminLogType', { authKey: localStorage.getItem('authKey') }).then(res => {
      for (let i = 0; i < res.length; i++) {
        this.typeList.push(res[i])
      }
    })

    this.load()
  }
}
</script>
